import Vue from 'vue'
import Vuex from 'vuex'
import arraySort from "array-sort"
import lockr from "lockr"
import axios from "axios"
import VueAxios from 'vue-axios'
import {Utils} from "./classes/Utils"

Vue.use(Vuex);

// Global Default Settings für Axios
axios.defaults.timeout = 5000;

Vue.use(VueAxios, axios);

export default new Vuex.Store({
    state: {
        installPrompt: null,
        gIdToken: "",
        gName: "",
        gEmail: "",
        gImage: "",
        darkMode: false,
        sideNav: false,
        lastCalcAction: '',
        netto: '',
        brutto: '',
        mwst: '',
        resetAvailable: false,
        steuersatz: {
            id: 0, val: 19
        },
        steuersaetze: [
            {
                id: 0,
                val: 19,
            },
            {
                id: 1,
                val: 7
            }
        ],
        sideNavItems: [
            [
                {
                    title: "Anmelden",
                    icon: "icon-person",
                    path: "/anmelden"
                },
                {
                    title: "Steuersätze",
                    icon: "icon-percent",
                    path: "/steuersaetze"
                },
                {
                    title: "Einstellungen",
                    icon: "icon-cog",
                    path: "/einstellungen"
                },
                {
                    isDivider: true
                }
            ],
            [
                {
                    title: "Feedback senden",
                    icon: "icon-bullhorn",
                    path: "/feedback"
                },
                {
                    isDivider: true
                }
            ],
            [
                {
                    title: "Datenschutz",
                    icon: "icon-file-text",
                    path: "/datenschutz"
                },
                {
                    title: "Impressum",
                    icon: "icon-info",
                    path: "/impressum"
                },
                {
                    isDivider: true
                }
            ],
            [
                {
                    title: "Weitere Apps",
                    icon: "icon-apps",
                    path: "/apps"
                }
            ]
        ]
    },
    mutations: {

        /* Mutation-Funktion sind SETTER-Funktionen für die State-Variablen */

        setGEmail: (state, payload) => {
            state.gEmail = payload;
        },

        setGName: (state, payload) => {
            state.gName = payload;
        },

        setGToken: (state, payload) => {
            state.gIdToken = payload;
        },

        setInstallPrompt: (state, payload) => {
            state.installPrompt = payload;
        },

        setGImage: (state, payload) => {
            state.gImage = payload;
        },

        setDarkMode: (state, payload) => {
            state.darkMode = payload;

        },

        setSideNav: (state, payload) => {
            state.sideNav = payload;
        },

        setNetto: (state, payload) => {
            state.netto = payload;
        },

        setBrutto: (state, payload) => {
            state.brutto = payload;
        },

        setMwst: (state, payload) => {
            state.mwst = payload;
        },

        setResetAvailable: (state, payload) => {
            state.resetAvailable = payload;
        },

        setSteuersatz: (state, payload) => {
            state.steuersatz = payload;
        },

        setSteuersaetze: (state, payload) => {
            state.steuersaetze = payload;

        },

        setLastCalcAction: (state, payload) => {
            state.lastCalcAction = payload;
        }
    },
    actions: {

        initStore: (state) => {

            // default aus dem local Storage auslesen
            let darkmode = lockr.get("darkMode", false);
            let saetze = lockr.get("steuersaetze", []);
            let satz = lockr.get("steuersatz", false);

            state.commit("setDarkMode", darkmode);
            if ( saetze.length > 0 ) {
                state.commit("setSteuersaetze", saetze);
            }
            if ( satz !== false ) {
                state.commit("setSteuersatz", satz);
            }

            // Wenn bei Google angemeldet
            if ( state.getters.gIsLoggedIn === true ) {

                // GET Einstellung für DarkMode
                axios.get("https://apiv1.software-schiek.de/mwst/einstellung/" + state.getters.gToken + "/darkMode")
                    .then(response => {
                        if ( response.status === 200 && typeof( response.data ) === "object"  ) {

                            if ( typeof ( response.data["wert"] ) !== "undefined" ) {
                                //console.log("eingelesen");
                                let apiValue = ( response.data["wert"] === "1" );

                                state.commit("setDarkMode", apiValue);
                                lockr.set("darkMode", apiValue);
                            }
                            else {
                                //console.log("NICHT eingelesen");
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })


                // GET aus BackendAPI
                axios.get("https://apiv1.software-schiek.de/mwst/steuersaetze/" + state.getters.gToken)
                    .then(response => {
                        if ( response.status === 200 && typeof( response.data ) === "object"  ) {

                            let saetze = [];
                            let currentSatz;
                            for(let key in response.data) {
                                saetze.push({
                                    id: parseInt(response.data[key].id_steuersatz),
                                    val: parseInt(response.data[key].value)
                                });

                                if ( parseInt(response.data[key]['isCurrent']) === 1 ) {
                                    currentSatz = {
                                        id: parseInt(response.data[key]['id_steuersatz']),
                                        val: parseInt(response.data[key]['value'])
                                    };
                                }
                            }

                            // LocaleStorage aktualisieren
                            state.commit("setSteuersaetze", saetze);
                            lockr.set("steuersaetze", saetze);

                            state.commit("setSteuersatz", currentSatz);
                            lockr.set("steuersatz", currentSatz);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })



            }




        },

        initGoogleSignIn: (state, payload) => {

            return payload()
                .then(gapi => {
                    return gapi.auth2.getAuthInstance()
                        .then(authInstance => {
                            let token = authInstance.currentUser.get().getAuthResponse().id_token;
                            let profile = authInstance.currentUser.get().getBasicProfile();

                            if ( typeof profile !== "undefined" ) {

                                let name = profile.getGivenName();
                                let email = profile.getEmail();
                                let image = profile.getImageUrl();

                                if ( typeof profile !== "undefined" ) {
                                    state.commit("setGToken", token);
                                    state.commit("setGEmail", email );
                                    state.commit("setGName", name );
                                    state.commit("setGImage", image );
                                }

                                return { email, name, image }
                            }

                        })

            })

        },


        sideNav: (state, val) => {
            state.commit("setSideNav", val);
        },

        installPrompt: (state, val) => {
            state.commit("setInstallPrompt", val);
        },

        darkMode: (state, val) => {
            state.commit("setDarkMode", val);

            lockr.set("darkMode", val);

            if ( state.getters.gIsLoggedIn === true ) {
                // POST an BackendAPI
                axios.post("https://apiv1.software-schiek.de/mwst/einstellung", {
                        data: {
                            name: "darkMode",
                            wert: (val === true ) ? "1" : "0"
                        },
                        id_token: state.getters.gToken
                    })
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        },

        /* actions führen mutation-funktionen aus */
        netto: (state, val) => {
            state.commit("setNetto", val);
            state.dispatch("isResetAvailable", state)
                .then((response) => {
                    state.commit("setResetAvailable", response);
                });
        },

        brutto: (state, val) => {
            state.commit("setBrutto", val);
            state.dispatch("isResetAvailable", state)
                .then((response) => {
                    state.commit("setResetAvailable", response);
                });
        },

        mwst: (state, val) => {
            state.commit("setMwst", val);
            state.dispatch("isResetAvailable", state)
                .then((response) => {
                    state.commit("setResetAvailable", response);
                });
        },

        lastCalcAction: (state, val) => {
            state.commit("setLastCalcAction", val);
        },

        clearValues: state => {
            state.commit("setNetto", '');
            state.commit("setBrutto", '');
            state.commit("setMwst", '');

            state.dispatch("isResetAvailable", state)
                .then((response) => {
                    state.commit("setResetAvailable", response);
                });

        },

        isResetAvailable: state => {

            if ( ( Utils.isNullOrEmpty(state.getters.netto)
                && Utils.isNullOrEmpty(state.getters.brutto)
                && Utils.isNullOrEmpty(state.getters.mwst) ) === false ) {
                return true;
            }

            return false;
        },

        steuersatz: (state, val) => {
            state.commit("setSteuersatz", val);

            lockr.set("steuersatz", val);

            let data = state.getters.steuersatz;

            if ( state.getters.gIsLoggedIn === true ) {
                // POST an BackendAPI
                axios.post("https://apiv1.software-schiek.de/mwst/steuersatz", {
                        data,
                        id_token: state.getters.gToken
                    })
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        },

        steuersatzAdd: (state, val) => {
            let saetze = state.getters.steuersaetze;
            let nextId = 0;

            //console.log("add");

            val = parseFloat(val);

            if ( saetze.length === 0 ) {
                nextId = -1;
            }
            else {
                let key;
                for( key in saetze ) {

                    if ( val === saetze[key].val ) {
                        // Bereits vorhanden
                        return false;
                    }

                    // den höchsten Index setzen
                    //console.log(nextId  + " === " + saetze[key].id);

                    if ( nextId < saetze[key].id ) {
                        nextId = saetze[key].id;
                    }
                }
            }

            saetze.push({
                id: ++nextId,
                val: val
            });

            //console.table(saetze);

            state.commit("setSteuersaetze", saetze);

            lockr.set("steuersaetze", saetze);

            // POST an BackendAPI
            if ( state.getters.gIsLoggedIn === true ) {
                // POST an BackendAPI
                axios.post("https://apiv1.software-schiek.de/mwst/steuersaetze", {
                        data: saetze,
                        id_token: state.getters.gToken
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }



            return true;
        },

        refreshCurrentSelection: (state) => {
            // Prüfen ob der aktuell gesetzte Steuersatz überhaupt noch vorhanden ist
            // Wenn nicht dann versuchen den nächsten zu setzen
            let saetze = state.getters.steuersaetze;
            let currentFound = false;
            let key;

            for( key in saetze ) {
                if ( saetze[key].val === state.getters.steuersatz.val ) {
                    currentFound = true;
                    break;
                }
            }

            if ( currentFound === false ){
                state.dispatch("steuersatz", state.getters.steuersaetze[0]);

                if ( state.getters.gIsLoggedIn === true ) {
                    // POST an BackendAPI
                    axios.post("https://apiv1.software-schiek.de/mwst/steuersatz", {
                            data: state.getters.steuersaetze[0],
                            id_token: state.getters.gToken
                        })
                        .then(response => {
                            console.log(response);
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            }
        },

        deleteAccount: (state) => {

            // POST an BackendAPI
            if ( state.getters.gIsLoggedIn === true ) {
                // POST an BackendAPI
                axios.post("https://apiv1.software-schiek.de/mwst/account/delete", {
                        id_token: state.getters.gToken
                    })
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }

        },

        steuersatzRemove: (state, id) => {
            let saetze = state.getters.steuersaetze;
            let deleteIndex = 0;
            let key;
            for( key in saetze ) {
                if ( saetze[key].id === id ) {
                    break;
                }
                deleteIndex++;
            }
            saetze.splice(deleteIndex, 1);

            state.commit("setSteuersaetze", saetze);

            lockr.set("steuersaetze", saetze);

            // POST an BackendAPI
            if ( state.getters.gIsLoggedIn === true ) {
                // POST an BackendAPI
                axios.post("https://apiv1.software-schiek.de/mwst/steuersaetze", {
                        data: saetze,
                        id_token: state.getters.gToken
                    })
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }
    },
    getters: {
        /* Value direkt aus dem STATE zurückgeben */

        darkMode: state => {
            return state.darkMode;
        },

        installPrompt: state => {
            return state.installPrompt;
        },

        sideNav: state => {
            return state.sideNav;
        },

        netto: state => {
            return state.netto;
        },

        brutto: state => {
            return state.brutto;
        },

        mwst: state => {
            return state.mwst;
        },

        resetAvailable: state => {
            return state.resetAvailable;
        },

        gToken: state => {
            return state.gIdToken;
        },

        gName: state => {
            return state.gName;
        },

        gEmail: state => {
            return state.gEmail;
        },

        gIsLoggedIn: state => {

            if ( typeof ( state.gIdToken ) !== "undefined" && state.gIdToken !== ""
                && typeof ( state.gEmail ) !== "undefined" && state.gEmail !== "" ) {
                return true;
            }

            return false;

        },

        steuersatz: state => {

            return state.steuersatz;
        },

        sideNavItems: state => {

            if ( state.gName !== "" ) {
                state.sideNavItems[0][0]["title"] = state.gName;
                state.sideNavItems[0][0]["picture"] = state.gImage;
            }

            return state.sideNavItems;
        },

        steuersaetze: state => {

            let saetze = state.steuersaetze;

            //console.log("getter");
            saetze = arraySort(saetze, 'val', { reverse: true});

            return saetze;
        },

        lastCalcAction: state => {
            return state.lastCalcAction;
        }
    }
})
